import { z } from "zod";
import { DateTimeWithOffset } from "@/lib/api/schemas/patterns";

/** Public invitation info shown on the /register page (GET register/{token}/). */
export const InvitationInfoOut = z.object({
  email: z.string(),
  client_name: z.string(),
  expires_at: DateTimeWithOffset,
});

/** Body for completing registration from an invitation link (POST register/). */
export const RegisterIn = z.object({
  token: z.string(),
  password: z.string(),
  first_name: z.string().nullish(),
  last_name: z.string().nullish(),
});

/** Registration result — carries the JWT for the freshly created session. */
export const RegisterOut = z.object({
  success: z.boolean(),
  message: z.string(),
  token: z.string(),
});
